import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { ThemeOption, ThemeService } from 'src/app/services/theme.service';
import { ViewService } from 'src/app/services/view.service';
import { ToastService } from 'src/app/services/toast.service';
import { InvoicesService } from 'src/app/services/invoices.service';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
})
export class TopNavComponent {
  constructor(
    private authService: AuthService,
    private invoicesService: InvoicesService,
    private firebaseService: FirebaseService,
    private themeService: ThemeService,
    public viewService: ViewService,
    private toastService: ToastService
  ) {}

  signOut() {
    this.authService.signOut().subscribe();
  }

  get signedIn() {
    return Boolean(this.authService.currentUser);
  }

  get currentTenant() {
    return this.authService.currentTenantInfo?.tenant;
  }

  get darkModeEnabled() {
    return this.themeService.theme === 'accuzipDarkTheme';
  }

  get userImageURL() {
    if (!this.firebaseService.currentUser) {
      return;
    }

    return this.firebaseService.currentUser.photoURL;
  }

  get cartItemCount() {
    if (!this.invoicesService.pendingInvoice) {
      return 0;
    }

    return this.invoicesService.pendingInvoice.license_details.length;
  }

  copyAccountNumber() {
    if (this.currentTenant) {
      navigator.clipboard.writeText(this.currentTenant.account_number);
      this.toastService.addToast('info', 'Account number copied to clipboard');
    }
  }

  updateTheme(ev: Event) {
    const theme = (ev.target as HTMLSelectElement).value as ThemeOption;
    this.themeService.setTheme(theme, true);
  }

  handleThemeChange(ev: Event) {
    if (ev.target) {
      if ((ev.target as HTMLInputElement).checked) {
        this.themeService.setTheme('accuzipDarkTheme', true);
      } else {
        this.themeService.setTheme('accuzipLightTheme', true);
      }
    }
  }
}
